"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bury = void 0;
/* eslint-disable @typescript-eslint/ban-types */
const illegal_argument_exception_1 = require("../#lib/exceptions/illegal-argument-exception");
/**
 * Deeply inserts a value into an object at a nested path.
 * New sub-objects will be created along the path if they don't already exist.
 * Any value already *at* that location will be overwritten, and any non-object values along the path will be replaced with an object.
 */
function bury(destination, value, path) {
    if (typeof path === 'string') {
        return bury(destination, value, path.split('.'));
    }
    if (path.length === 0) {
        throw new illegal_argument_exception_1.IllegalArgumentException('Property path cannot be empty.');
    }
    const propertyKey = path[0];
    const destRecord = destination;
    if (path.length === 1) {
        destRecord[propertyKey] = value;
        return;
    }
    if (typeof destRecord[propertyKey] !== 'object' || destRecord[propertyKey] === null) {
        destRecord[propertyKey] = {};
    }
    return bury(destRecord[propertyKey], value, path.slice(1, path.length));
}
exports.bury = bury;
//# sourceMappingURL=#bury.js.map